import { OrganizedTimersEvent } from "@/types";
import isEqual from "lodash.isequal";
import { MutableRefObject, useEffect } from "react";

const useSaveAllowed = (
  editedTimer: OrganizedTimersEvent | null,
  originalTimer: OrganizedTimersEvent | null,
  saveAllowed: MutableRefObject<boolean>
) => {
  useEffect(() => {
    // if (editedTimer && originalTimer) {
    if (!editedTimer || !originalTimer) {
      saveAllowed.current = false;
      return;
    }

    // Title Check
    if (editedTimer.timer.name && !editedTimer.timer.name.trim()) {
      saveAllowed.current = false;
      return;
    }

    if (!isEqual(editedTimer, originalTimer)) {
      console.log("Setting save allowed to true");
      saveAllowed.current = true;
    } else {
      saveAllowed.current = false;
    }
  }, [editedTimer, originalTimer, saveAllowed]);
};

export default useSaveAllowed;
